import { Opportunity } from '../../types/content';
import { transformContent } from './content';

export const transformRecommendations = (data: any) => {
  const recommendations: any = structuredClone(data, {});
  if (recommendations.opportunities)
    recommendations.opportunities = recommendations.opportunities.map((opportunity: Opportunity) =>
      transformContent<Opportunity>(opportunity)
    );
  return recommendations;
};
